import { render, staticRenderFns } from "./declarationResult.vue?vue&type=template&id=72f3e9f4&scoped=true&"
import script from "./declarationResult.vue?vue&type=script&lang=js&"
export * from "./declarationResult.vue?vue&type=script&lang=js&"
import style0 from "./declarationResult.vue?vue&type=style&index=0&id=72f3e9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3e9f4",
  null
  
)

export default component.exports